import { render, staticRenderFns } from "./Typing_Dos_and_Donts.vue?vue&type=template&id=bf511468&"
import script from "./Typing_Dos_and_Donts.vue?vue&type=script&lang=js&"
export * from "./Typing_Dos_and_Donts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports